import { useQuery } from '@tanstack/react-query';

import { useRequest, queryClient, type QueryFunction } from '@frontend/api';

import type { Rule } from './types';

type QueryParams = {
  componentId: number | string;
};

const useAllRulesKey = ['rules', 'list'] as const;
export const getUseAllRulesKey = () => useAllRulesKey;

export const useGetAllRules: QueryFunction<
  Rule[],
  [],
  ReturnType<typeof getUseAllRulesKey>,
  QueryParams
> = ({ queryOptions, requestOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: getUseAllRulesKey(),
    queryFn: ({ signal }) => {
      return request<Rule[]>(`/rules`, {
        init: {
          signal,
        },
      });
    },
  });
};

export const invalidateAllRulesQuery = () => {
  queryClient.invalidateQueries({ queryKey: getUseAllRulesKey() });
};
